{
  "F201": {
    "coordinator": {
      "title": "A, B en C tellen niet op tot D",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F202": {
    "coordinator": {
      "title": "De stemmen op lijsten tellen niet op tot E",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F203": {
    "coordinator": {
      "title": "E, F en G tellen niet op tot H",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F204": {
    "coordinator": {
      "title": "Het totaal aantal stemmen op kandidaten is niet ingevuld",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F312": {
    "coordinator": {
      "title": "D is niet gelijk aan H min I plus J",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F401": {
    "typist": {
      "title": "Controleer het totaal van de lijst. Is dit veld op het papieren proces-verbaal ook leeg? Dan kan je verdergaan. (F.401)"
    },
    "coordinator": {
      "title": "Het totaal van de lijst is niet ingevuld",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F402": {
    "typist": {
      "title": "Controleer ingevoerde aantallen",
      "content": "De opgetelde stemmen op de kandidaten en het ingevoerde totaal zijn niet gelijk."
    },
    "coordinator": {
      "title": "De stemmen op kandidaten tellen niet op tot het lijsttotaal",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "F403": {
    "typist": {
      "title": "Controleer het totaal van de lijst",
      "content": "Als het totaal overeenkomt met het papieren proces-verbaal, controleer dan ook de waarde bij E.{political_group_number} bij <Link to=\"../voters_votes_counts\">Aantal kiezers en stemmen</Link>."
    },
    "coordinator": {
      "title": "Controleer het totaal van de lijst en E.{political_group_number} in rubriek 2.2",
      "content": "Je kan niet verder met dit proces-verbaal. Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "W001": {
    "typist": {
      "title": "Extra controle nodig",
      "content": "De gemarkeerde velden zijn anders dan in de eerste invoer."
    },
    "coordinator": {
      "title": "W.001 is er alleen voor invoerders",
      "content": "Voor de coördinator hebben we het scherm 'verschillen oplossen'."
    }
  },
  "W002": {
    "typist": {
      "title": "Verschil met andere invoer. Nieuwe invoer nodig",
      "content": "Een coördinator heeft beide invoeren vergeleken, en aangegeven dat in deze invoer fouten zijn gemaakt. Neem de gemarkeerde velden opnieuw over van het papieren proces verbaal.",
      "actions": "<ul><li>Heb je alles ingevuld en komt je invoer overeen met het papier? Ga dan verder.</li></ul>"
    },
    "coordinator": {
      "title": "W.002 is er alleen voor invoerders",
      "content": "Voor de coördinator hebben we het scherm 'verschillen oplossen'."
    }
  },
  "W204": {
    "coordinator": {
      "title": "Het totaal aantal uitgebrachte stemmen (H) is nul",
      "content": "Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "W205": {
    "coordinator": {
      "title": "Het aantal kiesgerechtigden (Z) is niet ingevuld",
      "content": "Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  },
  "W206": {
    "coordinator": {
      "title": "Het aantal kiesgerechtigden (Z) is kleiner dan het aantal stempassen (A)",
      "content": "Controleer of er iets is misgegaan bij het opmaken of overdragen van het proces-verbaal van het onderliggende niveau.\nBlijft de fout? Overleg dan met het CSB over de vervolgstappen."
    }
  }
}
